import { ISSUETYPE_FIELDKEY } from '@atlassian/jira-polaris-domain-field/src/field/constants.tsx';
import { FIELD_TYPES } from '@atlassian/jira-polaris-domain-field/src/field-types/index.tsx';
import {
	GENERIC_FIELD_FILTER,
	type FilterGroup,
	type IssueTypeGroupFilter,
} from '@atlassian/jira-polaris-domain-view/src/filter/types.tsx';

export const getIssueTypeNameFromGroupFilter = (groupFilter: IssueTypeGroupFilter) => {
	if (groupFilter?.type !== GENERIC_FIELD_FILTER) {
		return undefined;
	}

	if (groupFilter.field !== ISSUETYPE_FIELDKEY) {
		return undefined;
	}

	if (groupFilter.values.length === 0) {
		return undefined;
	}

	if (groupFilter.values[0].stringValue === undefined) {
		return undefined;
	}

	return groupFilter.values[0].stringValue;
};

export const createGroupFilterFromIssueTypeName = (
	issueTypeName: string,
): IssueTypeGroupFilter => ({
	type: GENERIC_FIELD_FILTER,
	field: ISSUETYPE_FIELDKEY,
	fieldType: FIELD_TYPES.ISSUE_TYPE,
	values: [{ stringValue: issueTypeName }],
});

export const excludeQuickFilter = (filterGroups: FilterGroup[]) =>
	filterGroups
		.map((filterGroup) => {
			if (filterGroup.groupFilter !== undefined) {
				return filterGroup;
			}

			const filters = filterGroup.filters.filter(
				(f) => !(f.type === 'TEXT' && f.localId === 'quick'),
			);

			if (!filters.length) {
				return null;
			}

			return {
				...filterGroup,
				filters,
			};
		})
		.filter(Boolean);
